import { storeToRefs } from 'pinia';
import { useDeviceDetectionStore } from '@/stores/device_detection.js';

export function useDeviceDetection() {
  const deviceStore = useDeviceDetectionStore();

  // Referencias reactivas del store
  const {
    isMobile,
    isTablet,
    isDesktop,
    deviceType,
    isPortrait,
    isLandscape,
    screenWidth,
    screenHeight,
    touchSupport,
    getDeviceInfo,
    isInitialized,
  } = storeToRefs(deviceStore);

  // Métodos del store
  const { detectDevice, updateScreenSize, initializeListeners, removeListeners } = deviceStore;

  // Funciones de utilidad adicionales
  const isScreenSize = (breakpoint) => {
    const breakpoints = {
      xs: 480,
      sm: 768,
      md: 1024,
      lg: 1280,
      xl: 1920,
    };

    return screenWidth.value <= breakpoints[breakpoint];
  };

  const getResponsiveValue = (values) => {
    if (isMobile.value && values.mobile !== undefined) {
      return values.mobile;
    }
    if (isTablet.value && values.tablet !== undefined) {
      return values.tablet;
    }
    if (isDesktop.value && values.desktop !== undefined) {
      return values.desktop;
    }
    return values.default || null;
  };

  const shouldShowMobileView = () => {
    const result = isMobile.value || (isTablet.value && isPortrait.value);
    return result;
  };

  const getDeviceClass = () => {
    const classes = [];

    if (isMobile.value) classes.push('device-mobile');
    if (isTablet.value) classes.push('device-tablet');
    if (isDesktop.value) classes.push('device-desktop');
    if (isPortrait.value) classes.push('orientation-portrait');
    if (isLandscape.value) classes.push('orientation-landscape');
    if (touchSupport.value) classes.push('touch-enabled');

    return classes.join(' ');
  };

  return {
    // Estados reactivos
    isMobile,
    isTablet,
    isDesktop,
    deviceType,
    isPortrait,
    isLandscape,
    screenWidth,
    screenHeight,
    touchSupport,
    getDeviceInfo,
    isInitialized,

    // Métodos del store
    detectDevice,
    updateScreenSize,
    initializeListeners,
    removeListeners,

    // Funciones de utilidad
    isScreenSize,
    getResponsiveValue,
    shouldShowMobileView,
    getDeviceClass,
  };
}
